export const NepaliMonth = ['Baisakh', 'Jestha', 'Asadh', 'Shrawan', 'Bhadra', 'Asoj', 'Kartik', 'Mangsir', 'Poush', 'Magh', 'Falgun', 'Chaitra']

export const NepaliMonthShort = ['Bai', 'Jes', 'Asa', 'Shr', 'Bha', 'Aso', 'Kar', 'Man', 'Pou', 'Mag', 'Fal', 'Cha']
